<template>
  <div class="agents-oferta-page">
    <AgentsOferta />
  </div>
</template>

<script>
import AgentsOferta from '@/components/agent/AgentsOferta.vue'

export default {
  name: 'AgentsOfertaPage',
  components: {
    AgentsOferta
  }
}
</script>

<style scoped>
.agents-oferta-page {
  padding: 20px;
}
</style>
